import { bus, playerBus, EVENT } from '@videotools/js/events';
import { APP_TYPE_TAGGING_TOOL, APP_TYPE_VIEW_MODE, APP_TYPE_COUCH_MODE } from '@videotools/js/constants/app';
import { events, taggingToolKeyActions, viewModeKeyActions, couchModeKeyActions, viewModeSmartTVNavBackActions } from '@videotools/js/constants/keyboardActions';

// TODO: Extract this, event bus modules are only supposed to export registration / unregistration functions.
const processHotkeys = (event, type, hotkeysDisabled) => {
	if (hotkeysDisabled) return;

	let actions = null;
	if (type === APP_TYPE_VIEW_MODE) {
		actions = viewModeKeyActions;
	} else if (type === APP_TYPE_TAGGING_TOOL) {
		actions = taggingToolKeyActions;
	} else if (type === APP_TYPE_COUCH_MODE) {
		actions = couchModeKeyActions;
	} else if (type === 'NAV_BACK') {
		actions = viewModeSmartTVNavBackActions;
	} else {
		return;
	}

	const keys = {
		key:      event.key?.toUpperCase(),
		shiftKey: event.shiftKey,
		altKey:   event.altKey,
		ctrlKey:  event.ctrlKey,
		metaKey:  event.metaKey, // command on mac
	};

	const hotkeyAction = actions.find((currentAction) => {
		const actionConditions = [
			currentAction.key === keys.key,
			!keys.shiftKey || currentAction.shiftKey === keys.shiftKey,
			!keys.altKey || currentAction.altKey === keys.altKey,
			!keys.ctrlKey || currentAction.ctrlKey === keys.ctrlKey,
			!keys.metaKey || currentAction.metaKey === keys.metaKey,
		];
		return actionConditions.every(Boolean);
	});
	if (!hotkeyAction) return;

	if (event.target.tagName === 'INPUT') return;

	bus.publish(hotkeyAction.action);

	event.preventDefault(); // prevent page scrolling on space/up & down arrows
};

const register = (busThatShouldBeUsed) => {
	busThatShouldBeUsed.subscribe(events.HOTKEY_PLAY_NEXT_TAG, () => {
		busThatShouldBeUsed.publish(EVENT.PLAYER.REQUEST.SEEK_NEXT_TAG);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_PLAY_PREVIOUS_TAG, () => {
		busThatShouldBeUsed.publish(EVENT.PLAYER.REQUEST.SEEK_PREVIOUS_TAG);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_EDIT_NEWEST_TAG, () => {
		busThatShouldBeUsed.publish(EVENT.TIMELINE_EDIT_LATEST_TAG);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_VOLUME_UP, () => {
		let { volume } = playerBus;

		if (volume > 90) volume = 100;
		else volume += 10;

		playerBus.setVolume(volume);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_VOLUME_DOWN, () => {
		let { volume } = playerBus;

		if (volume < 10) volume = 0;
		else volume -= 10;

		playerBus.setVolume(volume);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_PLAY_LAST_TAG, () => {
		busThatShouldBeUsed.publish(EVENT.PLAYER.REQUEST.SEEK_LAST_TAG);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_TOGGLE_FULLSCREEN, () => {
		playerBus.toggleFullscreen();
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_RESTART_PLAYER, () => {
		playerBus.seek(0);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_TOGGLE_MUTE, () => {
		if (playerBus.player.isMuted) playerBus.unmute();
		else playerBus.mute();
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_SEEK_BACKWARDS_TEN_SEC, () => {
		playerBus.seekBackward();
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_SEEK_FORWARDS_TEN_SEC, () => {
		playerBus.seekForward();
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_SEEK_BACKWARDS_ONE_SEC, () => {
		playerBus.seekBackward(1);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_SEEK_FORWARDS_ONE_SEC, () => {
		playerBus.seekForward(1);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_SEEK_BACKWARDS_ONE_FRAME, () => {
		playerBus.seekBackward(1 / 30);
	});

	busThatShouldBeUsed.subscribe(events.HOTKEY_SEEK_FORWARDS_ONE_FRAME, () => {
		playerBus.seekForward(1 / 30);
	});
};

export { events, processHotkeys };
export default register;
